import { BottomSheet, spacing } from "@stepapp/ui";
import { useRouter } from "expo-router";
import { useCallback, useState } from "react";
import { StyleSheet } from "react-native";
import { EditReservationScreen } from "../../screens";

type ModifyReservationProps = {
  reservationId: string;
  questionToEdit: string;
  setQuestionToEdit: (v: string) => void;
  isVisible: boolean;
};

const ModifyReservationSheet = ({
  reservationId,
  questionToEdit,
  setQuestionToEdit,
  isVisible,
}: ModifyReservationProps) => {
  const { replace } = useRouter();
  const [newReservationId, setNewReservationId] = useState("");

  const handleClose = useCallback(() => {
    setQuestionToEdit("");

    newReservationId && replace(`calendar/${newReservationId}`);
  }, [setQuestionToEdit, newReservationId, replace]);

  return (
    <BottomSheet
      avoidKeyboard
      containerStyle={styles.bottomSheetContainer}
      contentStyle={styles.container}
      enableScroll={false}
      toggle={handleClose}
      visible={isVisible}
    >
      <EditReservationScreen
        reservationId={reservationId}
        questionToEdit={questionToEdit}
        handleGoBack={handleClose}
        setNewReservationId={setNewReservationId}
      />
    </BottomSheet>
  );
};

export default ModifyReservationSheet;

const styles = StyleSheet.create({
  bottomSheetContainer: {
    justifyContent: "flex-end",
    paddingBottom: 0,
  },
  container: {
    paddingBottom: 0,
    padding: 0,
    maxHeight: spacing.deviceHeight * 0.9,
  },
});
